import { render, staticRenderFns } from "./BracketFinal.vue?vue&type=template&id=68ad92a3&"
import script from "./BracketFinal.vue?vue&type=script&lang=js&"
export * from "./BracketFinal.vue?vue&type=script&lang=js&"
import style0 from "./BracketFinal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports